<template>
  <div class="gauge-graph">
    <highcharts
      class="chart"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import getGaugePlotBands from '@shared/lib/lead/getGaugePlotBands';
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'GaugeGraph',
  mixins: [leadDetailMixin],
  computed: {
    chartOptions() {
      const {
        plotBands, min, max, gaugeValue,
      } = getGaugePlotBands(this.gaugeGraphData.graphType, this.gaugeGraphData.temp);
      const tickPositions = [min, max];
      return {
        chart: {
          height: 190,
          width: 226,
          backgroundColor: 'transparent',
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          type: 'gauge',
          marginTop: 15,
        },
        credits: {
          enabled: false,
        },
        title: false,
        pane: {
          center: ['50%', '70%'],
          startAngle: -90,
          size: '135%',
          endAngle: 90,
          background: {
            backgroundColor: '#434D6A',
            innerRadius: '60%',
            outerRadius: '100%',
            shape: 'arc',
            borderWidth: 0,
          },
        },
        plotOptions: {
          gauge: {
            animation: {
              duration: 0,
            },
          },
        },
        tooltip: {
          enabled: false,
        },
        yAxis: [{
          min,
          max,
          plotBands,
          minorTickInterval: null,
          tickWidth: 0,
          lineWidth: 0, // controls upper border of gauge
          tickPositions,
          gridLineColor: 'transparent',
          labels: {
            format: '{value}°',
            enabled: true,
            x: 0,
            y: 25,
            style: {
              fontSize: 18,
              color: 'white',
              fontWeight: 700,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
        }],
        series: [{
          data: [gaugeValue],
          dataLabels: {
            enabled: false,
          },
          dial: {
            backgroundColor: 'white',
            rearLength: 0,
            baseWidth: 6,
          },
          pivot: {
            backgroundColor: 'white',
            radius: 10,
          },
        }],
      };
    },
  },
};
</script>

<style lang="scss" scoped>

.gauge-graph {
  position: relative;
  .text {
    font-size: 30px;
    position: absolute;
    left: 20px;
    top: 14px;
    font-weight: 700;
  }
  .icon {
    position: absolute;
    top: 18px;
    right: 20px;
    .snow {
      height: 24px;
      width: 24px;
    }
    .flame {
      height: 24px;
      width: 20px;
    }
  }
  .view-details {
    position: absolute;
    bottom: 20px;
    font-size: 14.22px;
    font-weight: 400;
    color: $N50;
    display: flex;
    justify-content: center;
    left: 0;
    right: 0;
    text-decoration: underline;
    cursor: pointer;
    z-index: 1;
  }
}
</style>
